import React, { useState, useEffect } from 'react';
import {connect} from 'react-redux';
import { withTranslation } from 'react-i18next';
import { Link, useNavigate } from 'react-router-dom';
import withRouter from 'src/config/withRouter';
import moment from 'moment';
import { save_company, getCompanyFonts, remove_user, save_user, checkParentSessions } from 'src/store/action';
import { db, auth, } from 'src/config/firebase';
import CustomMetaData from 'src/hooks/CustomMetaData';
import { addGoogleScript, addFbScript, addTapfiliateScript } from 'src/hooks/ThirdPartyScript';
// material ui
import withAuth from 'src/screens/Parents/config/WithAuth';
import withStyles from '@mui/styles/withStyles';
import { Backdrop, CircularProgress, Box, useMediaQuery } from '@mui/material';
import { gotoCart } from '../config/Api';
import makeStyles from '@mui/styles/makeStyles';
import BottomNavigation from '@mui/material/BottomNavigation';
import BottomNavigationAction from '@mui/material/BottomNavigationAction';
import { RecentActorsOutlined, MonetizationOnOutlined, DashboardOutlined, NotificationImportantOutlined, ContactSupportOutlined, } from '@mui/icons-material';
import Skeleton from '@mui/material/Skeleton';
// components
import Header from '../components/Header';
import { AlertMessage } from 'src/screens/Partners/Service/components';
import profileImg from 'src/assets/images/man.png';
import ChatIcon from 'src/assets/images/chat.png';
import { englishFontFallbackMap, arabicFontFallbackMap } from 'src/screens/WhiteLabels/Templates/shared/fonts';
// dashboard
import DashboardIcon from 'src/assets/images/sidemenu/parent/dashboard.svg';
import BookingIcon from 'src/assets/images/sidemenu/parent/booking.svg';
import AppointmentIcon from 'src/assets/images/sidemenu/parent/appointment.svg';
import CourseIcon from 'src/assets/images/sidemenu/parent/course.svg';
import FileIcon from 'src/assets/images/sidemenu/parent/file.svg';
import CertificateIcon from 'src/assets/images/sidemenu/parent/certificate.svg';
import BillingIcon from 'src/assets/images/sidemenu/parent/billing.svg';
import CartIcon from 'src/assets/images/sidemenu/parent/cart.svg';
import ProfileIcon from 'src/assets/images/sidemenu/parent/profile.svg';
import LogoutIcon from 'src/assets/images/sidemenu/parent/logout.svg';
// import IconWrapper from './IconWrapper';
import { theme } from 'src/screens/WhiteLabels/Templates/Template1/Template';

const engColor = '#003E93';

const ColorCircularProgress = withStyles({
    root: {
      color: '#0F467A',
    },
})(CircularProgress);

const useStyles = makeStyles(theme=> ({
    backdrop: {
        zIndex: 111125,
        color: '#fff',
    },

    //  new style
    container:{
        display:'flex',
        flexDirection:'row',
        justifyContent:'space-between',
        width:'calc(100% - 40px)',
        padding:'20px',
        height:'calc(100vh - 40px)',
        [theme.breakpoints.between('xs','md')]: {
            flexDirection:'column',
            justifyContent:'unset',
        }
    },

    containerHeightNone:{
        [theme.breakpoints.between('xs','md')]: {
            height:'auto',
        }
    },

    rightDiv:{
        width:'calc(100% - 320px)',
        display:'flex',
        flexDirection:'column',
        position:'relative',
        overflow:'hidden',
        [theme.breakpoints.between('xs','md')]: {
            width:'100%',
            paddingBottom:'60px'
        }
    },

    // SideMenu class
    sideMenu:{
        width:'calc(300px - 20px)',
        position:'relative',
        display:'flex',
        flexDirection:'column',
        alignItems:'center',
        backgroundColor:'#FFFFFF',
        borderRadius:'25px',
        padding:'10px',
        boxShadow:'0px 3px 6px 0px #00000029',
        [theme.breakpoints.between('xs','md')]: {
            display: 'none'
        },
    },

    sideProfile:{
        width:'64px',
        height:'68px',
        '-webkit-border-radius': '99em',
        '-moz-border-radius': '99em',
        borderRadius: '99em',
        border: '5px solid #F3F7FD',
        boxShadow: '0 3px 2px rgb(0 0 0 / 21%)',
        '& img':{
            width:'100%',
            height:'100%',
            '-webkit-border-radius': '99em',
            '-moz-border-radius': '99em',
            borderRadius: '99em',
        }
    },

    menuName:{
        fontSize:'14px',
        textAlign:'center',
        color:'#000',
        textTransform:'capitalize',
        fontWeight:'bold'
    },

    menuSpan:{
        fontSize:'12px',
        color:'#707070',
        textAlign:'center',
        textTransform:'capitalize',
    },

    menuItem:{
        padding:'10px 14px',
        backgroundColor:'#fff',
        borderRadius:'5px',
        cursor:'pointer',
        display:'flex',
        flexDirection:'row',
        alignItems:'center',
        justifyContent:'flex-start',
        transition: 'background 0.5s',
    },

 

    menuIcon:{
        width:'18px',
        height:'18px',
        '& img':{
            width:'100%',
            height:'100%'
        }
    },

    menuItemHover:{
        '&:hover':{
            backgroundColor:'#f1f7ff',
        }
    },

    menuActive:{
        backgroundColor: engColor,
        '& span':{
            color:'#FFFFFF',
        }
    },

    logoutBtn:{
        backgroundColor:'#E9EDF3',
        outline:'none',
        border:'none',
        borderRadius:'5px',
        color:'#000000',
        fontSize:'16px',
        padding:'10px 14px',
        transition: 'background 0.5s',
        cursor:'pointer',
        display:'flex',
        flexDirection:'row',
        alignItems:'center',
        justifyContent:'flex-start',
        '&:hover':{
            backgroundColor: engColor,

            '& span':{
                color:'#fff !important'
            }
        }
    },

    walletSkelton:{
        width:'75px',
        height:'36px',
    },
    // side menu style end

    root: {
        display:'none',
        bottom: 0,
        width: '100%',
        padding:'0px',
        // display:'flex',
        // flexDirection:'row',
        // alignItems:'center',
        position: 'fixed',
        fontSize: '8px',
        // zIndex: 150,
        height: '5.5rem',
        fontFamily:'inherit',
        backgroundColor: '#fff',
        // borderTop:'1px solid #EBEBEC',
        // // marginLeft: '2px',
        fontFamily:'inherit',
        boxShadow:'0px -2px 6px 0px #00000029',
        borderTopLeftRadius:'12px',
        borderTopRightRadius:'12px',
        [theme.breakpoints.between('xs','md')]: {
            display:'flex'
        },

        '& .MuiSvgIcon-root': {
            width: '31px',
            height: '31px',
        },
        '& .MuiBottomNavigationAction-root':{
            fontSize:'10px',
            lineHeight:3,
            minWidth:'50px',
        },
        '& .MuiBottomNavigationAction-label': {
            color:'#979797',
            fontWeight: '100',
            fontFamily:'inherit',
            fontSize:'9px'
        },

        '& .Mui-selected': {
            fontWeight: 'bold',
            fontSize:'8px',
            color:'#000',
        }

    },

    rowDiv:{
        display:'flex',
        flexDirection:'row',
        alignItems:'center'
    },

    colDiv:{
        display:'flex',
        flexDirection:'column'
    }
}));

function PageLayout(props) {
    let { history, user,company, store_user, company_id, t, i18n, children, metaTitle, mobileTitle, backdropLoading, companyFonts } = props;
    const navigate = useNavigate();
    const [walletValue,setWalletValue] = useState('');
    const [walletCurrency,setWalletCurrency] = useState('');
    const [urlName,setUrlName] = useState('');
    const [domain,setDomain] = useState('');
    const [userLoader,setUserLoader] = useState(false);
    const [walletLoader,setWalletLoader] = useState(false);
    const [alertType,setAlertType] = useState('');
    const [message,setMessage] = useState('');
    const [openAlert,setOpenAlert] = useState(false);
    const [companySetting,setCompanySetting] = useState({});

    const isRTL = i18n.translator.language;
    const classes = useStyles();
    const englishFont = englishFontFallbackMap[companyFonts?.englishFont] || "'Poppins', serif";
    const arabicFont = arabicFontFallbackMap[companyFonts?.arabicFont] || '"Cairo", sans-serif';
    const fontFamily = isRTL === 'ar' ? arabicFont : englishFont;
    const whatsappNumber = company?.whatsappNumber || '';
    const { showMobileBottomNav = true } = companySetting || {};

    const fbEventTag = React.useRef(null);

    useEffect(()=> {
        function run() {
            if (!user) {
                history.push('/');
            } else if (!user.isParent) {
                history.push('/dashboard');
            } else {
                props._checkParentSessions(user.id);

                if (company_id) props.get_company_fonts(company_id);

                const ref = getUserLastedData(); // set up Firebase listener

                getCompanyURL();
                getTemplateSetting();
                addFbScript({ ref: fbEventTag, fbEvent: company?.fbEvent });
                addGoogleScript({ googleEvent: company?.googleEvent });
                addTapfiliateScript({ tapfiliateEvent: company?.tapfiliateEvent });
                return () => {
                if (ref) {
                    ref.off();
                    console.log("Firebase listener removed");
                }
                };
            }
        }
        const cleanup = run();
        return cleanup;
    },[user])

    const getTemplateSetting = () => {
        // get company template setting
        const companyId = company && company?.id || '';
        if(companyId) {
          db.ref('TemplateSettings/')
            .orderByChild('companyId')
            .equalTo(companyId)
            .on('value', (data) => {
                const templateData = data.val();
                if (templateData && Object.values(templateData)[0] !== null) {
                    setCompanySetting(Object.values(templateData)[0]);
                }
                else {
                    setCompanySetting({});
                }
            })
        }
    };

 const getUserLastedData = () => {
  const userId = user?.id || '';
  if (!userId) return null;

  setUserLoader(true);

  const ref = db.ref(`Users/${userId}/`);

  const listener = ref.on('value', (snapshot) => {
    const res = snapshot.val();

    if (res) {
      res.isParent = true;

      // Only update if data actually changed
      const current = user || {};
      const isDifferent = JSON.stringify(res) !== JSON.stringify(current);
        console.log("User data fetched:");
      if (isDifferent) {
        console.log("User changed, updating store");
        store_user(res); // <- this causes a re-render
        getWallet();
      } else {
        console.log("User same, no update");
      }
    }

    setUserLoader(false);
  });

  return ref; // So we can detach later
};

    const getWallet = () => {
        const parentId = user && user.id;
        const companyId = company && company.id;

        if(parentId && companyId) {
            setWalletLoader(true);
            db.ref(`ParentsWallets/`).orderByChild('parentId').equalTo(parentId).on('value',(data)=>{
                const wallet = data.val();
                let walletList = [];
                if(wallet) {
                    for(var i in wallet) {
                        if(wallet[i].companyId === companyId) {
                            walletList.push(wallet[i])
                        }
                    };
                    if(walletList.length > 0) {
                        setTimeout(()=> setWalletLoader(false),2000);
                        setWalletValue(walletList[0].walletValue ? walletList[0].walletValue : '');
                        setWalletCurrency(walletList[0].currency ? walletList[0].currency : '');
                    }
                    else{
                        setTimeout(()=> setWalletLoader(false),2000);
                        setWalletValue('');
                        setWalletCurrency('');
                    }
                }
                else{
                    setTimeout(()=> setWalletLoader(false),2000);
                    setWalletValue('');
                    setWalletCurrency('');
                }
            })
        }
    }

    const getCompanyURL = () => {
        const currentTime = moment().unix();
        if(company_id) {
            db.ref(`Companies/${company_id}/`).on('value',(data)=> {
                const res = data.val();
                if(res) {
                    const { planExpiryDate, subscriptionId } = res;
                    const _planExpiryDate = planExpiryDate ? Math.floor(new Date(planExpiryDate*1000).setDate(new Date(planExpiryDate*1000).getDate() + 3)/1000) : null;

                    const isExpire = subscriptionId && _planExpiryDate < currentTime;
                    if(isExpire) {
                        navigate('/not-found');
                    }
                    else{
                        const domain = res && res.domain ? res.domain : '';
                        const urlName = res && res.urlName ? res.urlName : '';
                        setDomain(domain);
                        setUrlName(urlName);
                    }
                }
            })
        }
    }

    const redirectHome = () => {
        const host = window.location.host;
        if(company_id) history.push(domain === host ? '/': urlName ? `/${urlName}` : `/company/${company_id}`);
    }

    const showAlert = (message,alertType) => {
        setAlertType(alertType);
        setOpenAlert(true);
        setMessage(message);
    } 
    const closeAlert = () => {
        setAlertType('');
        setOpenAlert(false);
        setMessage('');
    } 

    return(
        <>
        <CustomMetaData
            {...{
                title: company ? `${company.name} - ${metaTitle}` : `${company?.name} - ${metaTitle}`,
                image: company && company.avatar,
                description:company ? company.description : '',
                child:<style>{'body { background-color: #F3F7FD; }'}</style>
            }}
        />
        <div dir={isRTL === 'ar' ? 'rtl' :'ltr'}>
            <div className={`${classes.container} ${!showMobileBottomNav ? classes.containerHeightNone : ''}`}>
                <SideMenu 
                    {...{fontFamily,urlName,domain,walletValue,walletCurrency,userLoader, walletLoader,...props}}
                />

                <div className={classes.rightDiv} style={{fontFamily}}>
                    <Header mobileTitle={mobileTitle} walletValue={walletValue || ''} walletCurrency={walletCurrency || ''} />
                    {children}
                </div>
            </div>

            {showMobileBottomNav ?
                <_BottomNavigation {...{whatsappNumber,fontFamily,showAlert:showAlert,padding:'5.2rem',...props}}/>
            : null}

            <Backdrop className={classes.backdrop} open={backdropLoading}>
                <ColorCircularProgress />
            </Backdrop>

            <AlertMessage
                {...{
                    alertType,message,snackOpen:openAlert,
                    closeAlert: closeAlert
                }}
            />

            <div ref={fbEventTag}></div>
        </div>

        <WhatsappButton whatsappNumber={whatsappNumber} isRTL={isRTL}/>
        </>
    )
}

const mapStateToProps = state => {
    return {
        user: state.user,
        company:state.company,
        company_id: state.company_id,
        currentSession: state.uSession,
        cartList: state.cartList,
        companyFonts: state.cpFonts,
    }
}

const mapDispatchToProps = dispatch => {
    return {
        store_comp : company => dispatch(save_company(company)),
        logout_user : () => dispatch(remove_user()),
        store_user : user => dispatch(save_user(user)),
        get_company_fonts: companyId => dispatch(getCompanyFonts(companyId)),
        _checkParentSessions : (uid) => dispatch(checkParentSessions(uid))
    }
}

export default withRouter(connect(mapStateToProps,mapDispatchToProps)(withTranslation('common')(withAuth(PageLayout))));

function SideMenu(props) {
    const { user,fontFamily,t,userLoader, i18n, location, company_id, logout_user, urlName, domain, walletValue, walletCurrency, walletLoader, currentSession, cartList, company } = props;
    const isRTL = i18n.translator.language;
    const navigate = useNavigate();
    const classes = useStyles();
    const currentPath = location?.pathname;
   

    const onClickMenu = path => navigate(path);

    const logout = async () => {
        const companyId = company_id?.slice();
        const host = window.location.host;
        logout_user();
        auth.signOut();
        if(currentSession) db.ref(currentSession).remove();
        navigate(domain === host ? '/': urlName ? `/${urlName}` : `/company/${companyId}`)
    };

    const uid = user?.id || '';

    const menuList = [
        {label:t('component.sidebar.dashboard'),path:'/dashboard',icon:DashboardIcon},
        {label:t('component.sidebar.activeBooking'),path:'/my-booking',icon:BookingIcon},
        {label:t('component.sidebar.appointement'),path:'/appointments',icon:AppointmentIcon},
        // {label:t('component.sidebar.myCourse'),path:'',icon:CourseIcon},
        // {label:t('component.sidebar.file'),path:'',icon:FileIcon},
        {label:t('component.sidebar.certificate'),path:'/certificates',icon:CertificateIcon},
        {label:t('parentDashboard.billing'),path:'/billing',icon:BillingIcon},
        {label:t('component.sidebar.cart'), clickEvent: cartList?.length ? () => gotoCart({cartList,company,history:null,navigate}) : null,icon:CartIcon},
        {label:t('component.sidebar.myProfile'),path:'/my-account',icon:ProfileIcon},
        {label:t('parentDashboard.logout'),path:'',clickEvent:logout,icon:LogoutIcon,logoutBtn:true},
    ];

    return (
        <div className={classes.sideMenu}>
            <div className={classes.rowDiv} style={{width:'100%',marginTop:'35px',justifyContent:'space-between'}}>
                <div className={classes.sideProfile}>
                    {userLoader ?
                        <Skeleton variant="circular" animation="wave" width={64} height={68}/> 
                    :
                        <img src={user?.avatar || profileImg} alt={`${user?.firstName} ${user?.lastName}`} /> 
                    }
                </div>
                <div className={classes.colDiv} style={{width:'calc(100% - 90px)',alignItems:'flex-start'}}>
                    <span className={classes.menuName} style={{fontFamily}}>{`${user?.firstName || '---'} ${user?.lastName || ''}`}</span>
                    <span className={classes.menuSpan} style={{fontFamily,color:'#707070'}}>{t('parentDashboard.wallet')}</span>
                    {walletLoader ?
                        <Skeleton className={classes.walletSkelton} animation="wave"/> 
                    :
                        <span className={classes.menuSpan} style={{fontFamily,fontSize:'14px',color:'#000'}}>{walletValue ? `${walletValue} ${walletCurrency}` : '---'}</span>
                    }
                </div>
            </div>
            <div style={{paddingTop:'37px',width:'90%',alignSelf:'flex-start'}} className={classes.colDiv}>
                {React.Children.toArray(menuList.map(v=> {
                    return(
                        <div style={{marginBottom:'5px'}} className={v.logoutBtn ? classes.logoutBtn : `${classes.menuItem} ${v.path === currentPath ? classes.menuActive : classes.menuItemHover}`} onClick={v.path ? ()=> onClickMenu(v.path) : v.clickEvent ? v?.clickEvent : null}>
                            <div className={classes.menuIcon} style={isRTL === 'ar' ? {paddingLeft:'11px'} : {paddingRight:'11px'}}>
                                <img src={v.icon} alt={v.label} />
                            </div>
                            <span style={{fontFamily,fontSize:'16px',color:v.path === currentPath ? '#fff' : '#000000'}}>{v.label}</span>
                        </div>
                    )
                }))}
            </div>
        </div>
    );
}


function _BottomNavigation(props) {
    const { showAlert, t, isRTL, fontFamily, whatsappNumber, customCls } = props;
    const pathname = props.location.pathname;
    const classes = useStyles();
    let navValue = pathname === '/' ? 'dashboard' : pathname.slice(1);

    return(
        <div dir={isRTL === 'ar' ? 'rtl' :'ltr'} style={{fontFamily}} className={customCls || ''} pb={props.padding}>
            <BottomNavigation
                value={navValue}
                showLabels
                className={classes.root}
            >
                 <BottomNavigationAction
                    label={t('parentDashboard.myAccount')}
                    value='my-account'
                    icon={<RecentActorsOutlined />}
                    component={Link}
                    to="/my-account"
                />

                <BottomNavigationAction
                    label={t('company-setting.tabs.step4')}
                    value='billing'
                    icon={<MonetizationOnOutlined />}
                    component={Link}
                    to="/billing"
                />

                <BottomNavigationAction
                    label={t('component.bottombar.dashboard')}
                    value='dashboard'
                    icon={<DashboardOutlined />}
                    component={Link}
                    to="/dashboard"
                />

                <BottomNavigationAction
                    label={t('parentDashboard.announce')}
                    value='announcements'
                    icon={<NotificationImportantOutlined />}
                    component={Link}
                    to="/announcements"
                />

                <BottomNavigationAction
                    jaj={isRTL === "ar" ? '3px' : '10px'}
                    label={t('partner.dashboard.contact_us')}
                    value='contact us'
                    icon={<ContactSupportOutlined />}
                    onClick={()=> window.open(`https://wa.me/${whatsappNumber}`,'_blank')}
                />
            </BottomNavigation>
        </div>
    )
}

const WhatsappButton = ({ whatsappNumber, isRTL }) => {
  const matches = useMediaQuery(theme.breakpoints.up('sm'));
    const divStyle = matches ? {width:'79px',height:'79px'} : {width:'65px',height:'65px'};
    const imgDivStyle = matches ? {width:'48px',height:'44px'} : {width:'39px',height:'36px'};
  if(whatsappNumber)
  return(
    <Box position="fixed" zIndex={110} right={isRTL === 'ar' ? 'unset' : matches ? 30 : 2} left={isRTL === 'ar' ? matches ? 30 : 2 : 'unset'} bottom={matches ? 25 : 96}
        style={{
            ...divStyle,
            boxShadow:'0px 3px 6px 0px #00000029',
            display:'flex',
            flexDirection:'column',
            alignItems:'center',
            justifyContent:'center',
            borderRadius:'50px',
            backgroundColor:'#fff',
            cursor:'pointer'
        }}
        onClick={() => window.open(`https://wa.me/${whatsappNumber}`, '_blank')}
    >
      <div style={{...imgDivStyle}}>
        <img src={ChatIcon} alt='chat' style={{width:'100%',height:'100%'}} />
      </div>
    </Box>
  );

  return null;
};

export {
    _BottomNavigation,
    WhatsappButton
};